import { ca } from '@cian/analytics';
import { EPageBlock } from '../../../types/analytics';
import { INewbuildingPromo } from '../../../types/promosPage';

export const trackFreshPromoListShow = (promoList: INewbuildingPromo[]) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'show_sopr',
    label: 'Block',
    page: {
      extra: {
        block: EPageBlock.NewPromo,
        newbuilding_id: promoList.map(({ newbuildingId }) => newbuildingId),
      },
    },
  });
};

export const trackFreshPromoCardClick = ({ newbuildingId }: INewbuildingPromo) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Promo',
    action: 'Click',
    label: 'Block',
    page: {
      extra: {
        block: EPageBlock.NewPromo,
        newbuilding_id: newbuildingId,
      },
    },
  });
};
